import _slicedToArray from "/vercel/path0/.layouts/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var e = Object.defineProperty,
    t = Object.defineProperties,
    s = Object.getOwnPropertyDescriptors,
    r = Object.getOwnPropertySymbols,
    n = Object.prototype.hasOwnProperty,
    o = Object.prototype.propertyIsEnumerable,
    i = function i(t, s, r) {
  return s in t ? e(t, s, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : t[s] = r;
},
    c = function c(e, t) {
  for (var s in t || (t = {})) {
    n.call(t, s) && i(e, s, t[s]);
  }

  if (r) {
    var _iterator = _createForOfIteratorHelper(r(t)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var s = _step.value;
        o.call(t, s) && i(e, s, t[s]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return e;
};

import a, { useState as l, useEffect as u, useRef as m } from "react";
var g = "Please consider reporting this error at https://github.com/laymonage/giscus/issues/new.";

function d(e) {
  return "[giscus] An error occurred. Error message: \"".concat(e, "\".");
}

function p(e) {
  var t = document.querySelector("meta[property='og:".concat(e, "'],meta[name='").concat(e, "']"));
  return t ? t.content : "";
}

function f() {
  var e = document.getElementById("giscus-css") || document.createElement("style");
  e.id = "giscus-css", e.textContent = "\n    .giscus, .giscus-frame {\n      width: 100%;\n    }\n    .giscus-frame {\n      border: none;\n      color-scheme: normal;\n    }\n  ", document.head.prepend(e);
}

function h(e) {
  var _l = l(""),
      _l2 = _slicedToArray(_l, 2),
      r = _l2[0],
      n = _l2[1],
      o = function (_ref) {
    var e = _ref.repo,
        t = _ref.repoId,
        _ref$category = _ref.category,
        s = _ref$category === void 0 ? "" : _ref$category,
        _ref$categoryId = _ref.categoryId,
        r = _ref$categoryId === void 0 ? "" : _ref$categoryId,
        n = _ref.mapping,
        _ref$term = _ref.term,
        o = _ref$term === void 0 ? "" : _ref$term,
        _ref$theme = _ref.theme,
        i = _ref$theme === void 0 ? "light" : _ref$theme,
        _ref$reactionsEnabled = _ref.reactionsEnabled,
        c = _ref$reactionsEnabled === void 0 ? "1" : _ref$reactionsEnabled,
        _ref$emitMetadata = _ref.emitMetadata,
        a = _ref$emitMetadata === void 0 ? "0" : _ref$emitMetadata,
        _ref$inputPosition = _ref.inputPosition,
        l = _ref$inputPosition === void 0 ? "bottom" : _ref$inputPosition,
        _ref$lang = _ref.lang,
        u = _ref$lang === void 0 ? "en" : _ref$lang,
        m = _ref.session,
        g = _ref.origin;
    var d = new URL(location.href);
    d.searchParams.delete("giscus");
    var f = d.toString(),
        h = {
      origin: g = g || f,
      session: m,
      theme: i,
      reactionsEnabled: c,
      emitMetadata: a,
      inputPosition: l,
      repo: e,
      repoId: t,
      category: s,
      categoryId: r,
      description: p("description")
    };

    switch (n) {
      case "url":
        h.term = f;
        break;

      case "title":
        h.term = document.title;
        break;

      case "og:title":
        h.term = p("title");
        break;

      case "specific":
        h.term = o;
        break;

      case "number":
        h.number = o;
        break;

      case "pathname":
      default:
        h.term = location.pathname.length < 2 ? "index" : location.pathname.substring(1).replace(/\.\w+$/, "");
    }

    return "https://giscus.app/".concat(u, "/widget?").concat(new URLSearchParams(h));
  }((i = c({}, e), t(i, s({
    session: r
  }))));

  var i;
  var h = m(null);
  return u(function () {
    var e = location.href,
        t = new URL(e),
        s = localStorage.getItem("giscus-session"),
        r = t.searchParams.get("giscus") || "";
    if (r) return localStorage.setItem("giscus-session", JSON.stringify(r)), n(r), t.searchParams.delete("giscus"), void history.replaceState(void 0, document.title, t.toString());
    if (s) try {
      n(JSON.parse(s || "") || "");
    } catch (o) {
      n(""), localStorage.removeItem("giscus-session"), console.warn("".concat(d(null == o ? void 0 : o.message), " Session has been cleared."));
    }
  }, []), u(f, []), u(function () {
    var e = function (e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return function (s) {
        if ("https://giscus.app" !== s.origin) return;
        var r = s.data;
        if ("object" != typeof r || !r.giscus) return;
        if (t && r.giscus.resizeHeight && (t.style.height = "".concat(r.giscus.resizeHeight, "px")), !r.giscus.error) return;
        var n = r.giscus.error;

        if (n.includes("Bad credentials") || n.includes("Invalid state value")) {
          if (null !== localStorage.getItem("giscus-session")) return localStorage.removeItem("giscus-session"), e(), void console.warn("".concat(d(n), " Session has been cleared."));
          console.error("".concat(d(n), " No session is stored initially. ").concat(g));
        }

        n.includes("Discussion not found") ? console.warn("[giscus] ".concat(n, ". A new discussion will be created if a comment/reaction is submitted.")) : console.error("".concat(d(n), " ").concat(g));
      };
    }(function () {
      return n("");
    }, h.current);

    return window.addEventListener("message", e), function () {
      return window.removeEventListener("message", e);
    };
  }, []), a.createElement("div", {
    className: "giscus"
  }, a.createElement("iframe", {
    className: "giscus-frame",
    title: "Comments",
    scrolling: "no",
    src: o,
    ref: h
  }));
}

function b(e) {
  var _l3 = l(!1),
      _l4 = _slicedToArray(_l3, 2),
      t = _l4[0],
      s = _l4[1];

  return u(function () {
    return s(!0);
  }, []), t ? a.createElement(h, c({}, e)) : null;
}

export { b as Giscus };